/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// TODO: Figure out how to remove `mat-` classes from the CDK part of the
// column resize implementation.

export const HEADER_CELL_SELECTOR = '.cdk-header-cell, .mat-header-cell';

export const HEADER_ROW_SELECTOR = '.cdk-header-row, .mat-header-row';

export const RESIZE_OVERLAY_SELECTOR = '.mat-column-resize-overlay-thumb';
